<template>
  <div class="cat-card cl-container">
    <template v-if="busy">
      <div class="dummy-card">
        <div class="dummy-card-image"></div>
        <div class="dummy-card-title"></div>
        <div class="dummy-card-text"></div>
      </div>
      <div class="dummy-card">
        <div class="dummy-card-image"></div>
        <div class="dummy-card-title"></div>
        <div class="dummy-card-text"></div>
      </div>
    </template>
    <ImageCard v-else
      :cardLecture="item"
      :isList="true" 
      v-for="(item, index) in recommendCardLectures" :key="index" />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'card-lecture',

    data() {
      return {
        busy: false,
        page: 1,
        limit: 4,
      };
    },

    computed: {
      ...mapGetters({
        recommendCardLectures: 'getRecommendCardLectures',
      }),
    },

    methods: {
      ...mapActions([
        'fetchMainRecommendCardLectures',
      ]),
    },

    beforeMount() {
      this.busy = true;
      const filters = {
        page: this.page,
        per_page: this.limit,
      };
      this.fetchMainRecommendCardLectures(filters)
        .then(() => {
          this.busy = false;
        });
    },
  };
</script>

<style lang="scss" scoped>
  .cat-card {
    .dummy-card {
      width: 220px;
      height: 306px;
      background: #ffffff;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.05);
      margin: 14px;
      display: inline-block;

      .dummy-card-image {
        padding: 46px 0px 86px 0px;
        margin: 0px 0px 14px 0px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      .dummy-card-title {
        padding: 8px 0px 8px 0px;
        margin: 0px 14px 14px 14px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      .dummy-card-text {
        padding: 6px 0px 6px 0px;
        margin: 0px 14px 14px 14px;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// CardLecture.vue?45d7bf94